module.exports = __webpack_public_path__ + "ad9c3005737b76e8f8b7ee167c63ea1e.woff";


//////////////////
// WEBPACK FOOTER
// ./~/react-html5video/src/assets/font/video-fontello.woff?1445970113105
// module id = 1435
// module chunks = 0